// extracted by mini-css-extract-plugin
module.exports = {"bottle-animation":"BottleAnimation_bottle-animation__3Xsw0"};